<template>
  <v-container v-if="cargando">
    <v-btn color="orange" @click="volver" left dark> Volver </v-btn>
    <h3 style="margin-top:40px">Nuevo Grupo</h3>
    <v-form>
      <v-text-field
        v-model="nombre"
        :rules="reglaTexto"
        label="Nombre"
        append-icon="mdi-account"
        required
      ></v-text-field>
      <v-textarea
          outlined
          style="margin-top:40px"
          name="input-7-4"
          label="Descripción"
          :rules="reglaTexto"
          v-model="descripcion"
      ></v-textarea>
      <v-card flat color="#FFFAF3">
        <h5>Accesos</h5>
        <v-card-text>
          <v-row>
            <v-col v-for="(item) in arrayAccesos" :key="item" cols="12" sm="4" md="4">
              <v-checkbox
                v-model="arrayAccesosSeleccionados"
                :label="item"
                :value="item"
                color="green"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
          <v-btn style="margin-top:20px" color="green"  @click="nuevoGrupoAccesos"  dark>
            Añadir
            <v-icon right dark> mdi-group </v-icon>
          </v-btn>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import ApiZD from "../apiZonaDeDescargas";
export default {
  data () {
    return{
      nombre: "",
      reglaTexto: [(v) => !!v || "Campo Requerido"],
      descripcion:"",
      arrayAccesos: [],
      arrayAccesosSeleccionados: [],
      cargando: false
    }
  },
  methods:{

    obtenerArrayCarpetasPrimerNivel() {
      ApiZD.obtenerCarpetasPrimerNivel()
        .then((resultado) => {
          this.arrayAccesos = resultado.data.carpetas;
        })
        .catch((e) => {
          this.$router.push({ path: "/principalUsuarios" });
        })
        .finally(() => {
          this.cargando = true;
        });
    },

    //Añade un nuevo grupo de acceso a la bbdd
    nuevoGrupoAccesos () {
      if (this.nombre == "" || this.descripcion == "") {
        this.$root.$dialogo.activarDialogo(
          "Fallo datos",
          "Rellena correctamente todos los datos para poder continuar",
          ["OK"]
        );
      } else {
      ApiZD.nuevoGrupoAccesos(this.nombre,this.descripcion,this.arrayAccesosSeleccionados)
        .then(() =>{
          this.$router.push({ path: "/principalUsuarios" });
        })
      }
    },
    volver() {
      this.$router.go(-1);
    }
  },
  created () {
    this.obtenerArrayCarpetasPrimerNivel();
  }
}
</script>

<style scoped>

</style>